export const formatFileName = (name: string) => {
	name = name.replace(/\s+/g, "_"); // substitui espaços em branco por underline
	name = name.replace(/[^a-zA-Z0-9_.]/g, ""); // remove caracteres especiais
	return name;
};